/* ---- THE COIN BOX · hub layer: live chips, gate, wallet strip ---- */
(function(){
  var CB = window.STATION_COINBOX; if (!CB) return;
  var IDS = (window.STATION_HUB_ORDER || []);
  function cabs(){ return [].slice.call(document.querySelectorAll('#cabs .cab')); }
  function paint(){
    cabs().forEach(function(el, i){
      var id = IDS[i]; if (!id) return;
      var free = CB.isFree(id);
      el.dataset.coin = id;
      el.dataset.free = free ? '1' : '0';
      var tag = el.querySelector('.cab-tag');
      if (tag){
        tag.classList.toggle('pay', !free);
        tag.textContent = free ? 'FREE PLAY \u00B7 THIS ROTATION' : '25\u00A2 \u00B7 ONE PLAY \u00B7 ' + CB.clock();
      }
      var b = el.querySelector('[data-play]');
      if (b){
        b.classList.toggle('btn-gold', !free);
        b.classList.toggle('btn-alien', free);
        b.textContent = free ? 'PLAY' : 'INSERT 25\u00A2';
      }
    });
    var s = document.getElementById('coinStrip');
    if (s) s.innerHTML = 'THE COIN BOX \u00B7 <b>' + CB.tokens() + '</b> TOKEN' + (CB.tokens()===1?'':'S') +
      ' \u00B7 THE DIAL TURNS IN <b>' + CB.clock() + '</b> \u00B7 <a href="' + CB.buyUrl + '">GET TOKENS</a>';
  }
  /* gate paid machines before the game opens */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-play],[data-daily]'); if (!b) return;
    var el = b.closest('.cab'); if (!el) return;
    var id = el.dataset.coin; if (!id) return;
    if (CB.isFree(id)) { CB.played(id); return; }
    if (CB.spend(id)) { paint(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var t = document.getElementById('coinToast');
    if (t){ t.hidden = false; t.innerHTML = 'THIS MACHINE WANTS A QUARTER \u00B7 <a href="' + CB.buyUrl + '">GET TOKENS</a> \u00B7 OR FIND ONE THAT IS FREE RIGHT NOW';
            clearTimeout(window.__ctT); window.__ctT = setTimeout(function(){ t.hidden = true; }, 4200); }
  }, true);
  window.addEventListener('coinbox', paint);
  var boot = setInterval(function(){ if (cabs().length){ clearInterval(boot); paint(); } }, 120);
})();
